import { Component, inject, Injectable } from '@angular/core';
import { of } from "rxjs";
import { NgWizardModule, NgWizardConfig, NgWizardService, STEP_STATE, StepChangedArgs, StepValidationArgs } from 'ng-wizard';

@Injectable()


@Component({
    selector: 'sas-wizard',
    standalone: true,
    imports: [NgWizardModule],
    templateUrl: './sas-wizard.component.html',
    styleUrl: './sas-wizard.component.scss'
})

export class SasWizardComponent {

    protected swConfig: NgWizardConfig = {
        selected: 0,
        toolbarSettings: {
            showNextButton: false
        }
    }

    protected stepStates = {
        normal: STEP_STATE.normal,
        disabled: STEP_STATE.disabled,
        error: STEP_STATE.error,
        hidden: STEP_STATE.hidden,
    };
    constructor(protected ngWizardService: NgWizardService ) {
        
    }


    showPreviousStep(event?: Event) {
        this.ngWizardService.previous();
    }

    showNextStep(event?: Event) {
        this.ngWizardService.next();
    }

    resetWizard(event?: Event) {
        this.ngWizardService.reset();
    }

    stepChanged(args: StepChangedArgs) {
        console.log(args.step);
        // this.setStepChangedArgs(args);
    }

    isValidTypeBoolean: boolean = true;

    isValidFunctionReturnsBoolean(args: StepValidationArgs) {
        return true;
    }

    isValidFunctionReturnsObservable(args: StepValidationArgs) {
        return of(true);
    }
}
